<template>
  <component
    :is="hComponent"
    v-if='raw'
  >
    <slot />
  </component>
  <w-row v-else-if='onlyColumn === false'>
    <w-column class='pb-0'>
      <component :is="hComponent">
        <slot />
      </component>
    </w-column>
  </w-row>
  <w-column
    v-else
    cols='12'
    class='pb-0'
  >
    <component :is="hComponent">
      <slot />
    </component>
  </w-column>
</template>

<script>
/**
 * @component WorkInlineTitle
 * @description Inline heading with configurable HTML element and layout.
 * Can be rendered as a simple component, within a column or in a row.
 *
 * @prop {Boolean} [raw=false] - Render without layout container.
 * @prop {Boolean} [onlyColumn=false] - Render in a single column (without row).
 * @prop {String} [hComponent='h5'] - HTML heading element (`h1`–`h6`).
 *
 * @slot default - Title text.
 */
export default {
  name: 'WorkInlineTitle',
  props: {
    raw: { type: Boolean, default: false },
    onlyColumn: { type: Boolean, default: false },
    hComponent: { type: String, default: 'h5' }
  },
};
</script>
